import { atom } from "jotai";
import { getStorage } from "./storage";

export type User = {
  displayName: string;
  profilePicture: string;
  capabilities: string[];
  expires: Date;
};

export const userAtom = atom(getStorage<User>("user"));
